(ns frontend.view.components.power-search.key-hint.view
  (:require))

(defn key-hint
  [props & children]
  (fn [{:keys [hidden? small? fg-color bg-color]}]
    [:div {:class "text-xs text-base-light-text-paler hover:text-base-light-text-accent cursor-pointer"}
     children]))
